import React from 'react'
import Dropdown from 'components/common/dropdowns/Dropdown'
import colors from 'utility/colors'
import { usePartnerMarkets } from 'hooks/api/partner/usePartnerMarkets'
import FormLabel from 'components/common/forms/elements/FormLabel'

export const PartnerMarketsDropdown = ({
	title = 'Select a Market',
	onSelect,
	value,
	disabled = false,
	labelStyle = {},
	style = {},
}) => {
	const { data: markets } = usePartnerMarkets()

	const defaultLabelStyle = {
		color: colors.GRAY,
		fontWeight: 'bold',
		fontSize: '14px',
		marginBottom: 7,
	}

	const selectedValue = markets?.find((market) => market.id === value)

	return (
		<div style={style}>
			<FormLabel required style={{ ...defaultLabelStyle, labelStyle }}>
				MARKET
			</FormLabel>
			<Dropdown
				cardStyle={{ width: '100%', maxHeight: 300, overflowY: 'auto' }}
				style={{ width: '100%', height: '100%' }}
				color={colors.BLACK}
				onSelect={onSelect}
				buttonStyle={{
					backgroundColor: colors.WHITE,
					borderColor: colors.WHITE,
				}}
				disabled={disabled}
				defaultTitle={title}
				options={markets?.map((market) => {
					return {
						title: market.name,
						data: market,
						onClick: onSelect,
					}
				})}
			>
				{selectedValue?.name || title}
			</Dropdown>
		</div>
	)
}
